import { Checkall } from "./checkall"
import { Modal } from "./modal"

let _instances = new WeakMap<Element, Listing>();

type ListingOptions = {
    onLoad: (el: HTMLElement) => void,
}

class Listing {
    elContainer: HTMLElement;
    elPages:     NodeListOf<HTMLElement>;
    elColumns:   NodeListOf<HTMLElement>;

    elCheckAll: HTMLInputElement;
    elCheckBoxes: NodeListOf<HTMLInputElement>;
    elSelectAction: HTMLSelectElement;

    constructor(container: Element, opts: Partial<ListingOptions> = {}) {
        this.elContainer  = container as HTMLElement;

        this.elPages = container.querySelectorAll('ul.pagination[data-page-name] > li.page[data-page]');
        this.elColumns = container.querySelectorAll(".table-column-order[data-order-name]");

        this.init();

        _instances.set(container, this);
    }

    static instance(el: Element): Listing|null {
        return _instances.get(el);
    }

    init() {
        this.elPages.forEach((el) => {
            el.addEventListener("click", (e) => {

                const ul = el.parentNode as HTMLElement;

                var url = new URL(window.location.href);

                url.searchParams.set(ul.getAttribute('data-page-name'), el.getAttribute('data-page'));

                window.location.href = url.href;
            })
        })

        this.elColumns.forEach((el) => {
            el.addEventListener("click", (e) => {

                var url = new URL(window.location.href);

                url.searchParams.set(el.getAttribute('data-order-name')+'[]', el.getAttribute('data-order'));

                window.location.href = url.href;
            })
        })

        // Handle action checkboxes
        this.elSelectAction = this.elContainer.querySelector("select.table-action-select") as HTMLSelectElement;
        this.elCheckAll     = this.elContainer.querySelector("input.table-action-checkall") as HTMLInputElement;
        this.elCheckBoxes   = this.elContainer.querySelectorAll("input.table-action-checkbox") as NodeListOf<HTMLInputElement>;

        if (this.elCheckAll) {
            new Checkall(this.elCheckAll, this.elCheckBoxes, {
                afterChange: (changed: Array<HTMLInputElement>) => {
                    this.refreshSelectAction();
                },
            })
        }

        this.elCheckBoxes.forEach((el) => {
            el.addEventListener('change', (e) => {
                this.refreshSelectAction();
            })
        })

        if (this.elSelectAction) {
            this.initSelectAction();
        }

    }

    initSelectAction() {

        this.elSelectAction.addEventListener("change", (e) => {
            const index = this.elSelectAction.selectedIndex;

            if (index > 0) {
                this.onSelectAction(index, this.elSelectAction.options[index]);
            }
        })

        this.refreshSelectAction();
    }

    setUrlParams(base: string, params: Map<string, string>): string {
        let url = new URL(base, window.location.href);

        let urlParams = url.searchParams;

        params.forEach((v: string, k: string) => {
            urlParams.set(k, v);
        });

        return url.toString();
    }

    onSelectAction(index: number, el: HTMLOptionElement) {
        let selected: Array<string> = [];

        this.elCheckBoxes.forEach((el) => {
            if (el.checked) {
                selected.push(el.value)
            }
        })

        if (el.hasAttribute("data-post-url")) {

            const form = document.createElement("form");
            form.setAttribute("method", "POST")
            form.setAttribute("action", el.getAttribute("data-post-url"))
            
            const selInput = document.createElement("input");
            selInput.setAttribute("name", "selected");
            selInput.setAttribute("value", selected.join(","));
            form.appendChild(selInput);

            if (el.hasAttribute("data-csrf-name") && el.hasAttribute("data-csrf-value")) {
                const selCSRF = document.createElement("input");
                selCSRF.setAttribute("name",  el.getAttribute("data-csrf-name"));
                selCSRF.setAttribute("value", el.getAttribute("data-csrf-value"));
                form.appendChild(selCSRF);
            }

            document.body.appendChild(form);

            form.submit();

        } else if (el.hasAttribute("data-modal-url")) {
            
            const uri = this.setUrlParams(el.getAttribute("data-modal-url"), new Map([["selected", selected.join(",")]]))

            let modal = new Modal({
                "url": uri,
            })

            modal.addEventListener("modal.close", (e) => {
                modal.destroy();
            })

            modal.open();
        }

        this.elSelectAction.selectedIndex = 0;
    }

    refreshSelectAction() {
        const preview = this.elSelectAction.querySelector("option");
        const total   = this.elSelectAction.getAttribute('data-total');
        const format  = preview.getAttribute('data-select-format');

        let nSelected = 0;

        this.elCheckBoxes.forEach((el) => {
            if (el.checked) {
                nSelected += 1
            }
        })

        preview.innerText = format.replace("[n]", ""+nSelected).replace("[m]", total);

        if (nSelected == 0) {
            this.elSelectAction.setAttribute("disabled", "disabled");
        } else {
            this.elSelectAction.removeAttribute("disabled");
        }
    }
}

export { Listing };